import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../front-end/profile/Login";
import Dashboard from "../front-end/components/Dashboard";
const AppRoutes = () => {
  return (
    
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="*" element={<h1 >Page Not Found ISTL</h1>} />
    </Routes>
  );
};

export default AppRoutes;
